(function () {
    "use strict";

    HGifListComponent.$inject = ['$scope'];

    function HGifListComponent($scope) {

        var self = this;
        var searchTimeOut;
        var LIMIT = 20;
        var totalCount;

        self.gifs = [];
        self.searchText = '';
        self.loading = false;

        self.$onInit = function () {
            self.getGifs();
        };

        self.loadMoreGifs = function () {
            if (self.loading) {
                return
            }
            self.loading = true;
            var params = {
                limit: LIMIT,
                offset: self.gifs.length
            };
            var promise;
            if (self.searchText) {
                params.q = self.searchText
                promise = GifsAPI.getGifsSearch(params);
            }
            else {
                promise = GifsAPI.getGifsTrending(params);
            }
            promise
                .then(function (res) {
                    totalCount = res.pagination.total_count;
                    self.gifs = self.gifs.concat(res.data);
                    self.loading = false;
                    $scope.$digest();
                });
        }

        self.getGifs = function () {
            if (searchTimeOut) {
                clearTimeout(searchTimeOut)
            }
            searchTimeOut = setTimeout(function () {
                self.gifs = [];
                self.loadMoreGifs();
            }, 600);
        };

        self.$onChanges = function () {

        };

        self.$onDestroy = function () {

        };
    }

    var HGifListComponentOptions = {
        bindings: {
            onGifSelected: '&',
        },
        controller: HGifListComponent,
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-gifs/h-gif-list/h-gif-list.component.html'
    };

    angular
        .module('components')
        .component('hGifList', HGifListComponentOptions);
})();

